import { Box, Button, IconButton } from "@mui/material"
import { useStyles } from "./styles"
import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { LevelEnums, OptionValueType } from "../../enums"
import { useTranslation } from "react-i18next"
import Papa from 'papaparse';
import { v4 as uuidv4 } from "uuid";
import { DraggableItem } from "../draggableItem/types"
import { ObjectGeneric, onChange } from "../../../../../../../../../../utils/types/generals"
import { useCatalogStoreModule } from "../../context"
import { isRequired } from "../../../../../../../../../../utils/validate/validate"
import { InputModel } from "../../../../../../../../../../utils/types"
import { icons } from "../../../../../../../../../../utils/icons"
import { DinamicForm } from "../../../../../../../../../../components/dinamicForm"
import SimpleModal from "../../../../../../../../../../components/modal/simpleModal"
import { generateId, priorities } from "../../../../constans"


const FormLevel = ({ parentId, hasChild, level, id: itemId, rootId, subCatalogId }: { subCatalogId?: number; rootId: string, id: string, level: number; parentId: string | null, hasChild: boolean }) => {
    const { subValueTypes, subCatalog, addItem, editItem, editItemSubCatalog, selectedItem, clearChildren, collapseItemAndChildren, setSelectedItem, selectedItemRoot, setSelectedItemRoot, providers } = useCatalogStoreModule();
    const { t } = useTranslation()
    const styles = useStyles()
    const fileInputRef = useRef<HTMLInputElement | null>(null)
    const [allErrors, setAllErrors] = useState<ObjectGeneric>({})
    const [newSelectedItem, setNewSelectedItem] = useState<DraggableItem | null>(null);
    const [data, setData] = useState<ObjectGeneric>({
        subValue: null,
        typeSubValue: subCatalogId ? OptionValueType.SUB_CATALOG : OptionValueType.VALUE,
        subCatalog: subCatalogId ? subCatalogId : null,
        category: null,
        subCategory: null,
        priority: null,
        provider: null,
        textField: null
    })
    const [modal, setModal] = useState<{
        open: boolean
        title: string
        description?: string
        children?: JSX.Element
        removeCancel?: boolean
        confirm: () => void,
        cancel: () => void,
    }>({
        open: false,
        title: '',
        description: '',
        cancel: () => { },
        confirm: () => { },
    })

    const closeModal = () => {
        setModal(prev => ({
            ...prev,
            open: false,
        }))
    }

    const mainChange: onChange = useCallback((e, id): void => {
        const { name, value } = e?.target
        let body = { ...data }

        if (name == 'subValue') {
            if (isRequired(value)) {
                setAllErrors({ subValue: t('optionGroup.tags.errors.subValue') })
            } else {
                if ((value?.trim().length ?? 0) < 3) {
                    setAllErrors({ subValue: t('optionGroup.tags.errors.minLenght', { min: 3 }) })
                } else {
                    setAllErrors({ subValue: '' })
                }
            }
        }

        if (name == 'category') {
            if (isRequired(value)) {
                setAllErrors({ category: t('catalog.tags.errors.category') })
            } else {
                if ((value?.trim().length ?? 0) < 3) {
                    setAllErrors({ category: t('optionGroup.tags.errors.minLenght', { min: 3 }) })
                } else {
                    setAllErrors({ category: '' })
                }
            }
        }

        if (name == 'subCategory') {
            if (isRequired(value)) {
                setAllErrors({ subCategory: t('catalog.tags.errors.subCategory') })
            } else {
                if ((value?.trim().length ?? 0) < 3) {
                    setAllErrors({ subCategory: t('optionGroup.tags.errors.minLenght', { min: 3 }) })
                } else {
                    setAllErrors({ subCategory: '' })
                }
            }
        }

        if (name == 'typeSubValue' && hasChild && data.typeSubValue !== value) {
            const prevValue = data.typeSubValue
            const pendingValue = value
            setData(prev => ({
                ...prev,
                typeSubValue: pendingValue,
            }))
            setModal(prev => ({
                ...prev,
                open: true,
                title: t('optionGroup.modal.confirmation'),
                description: t('optionGroup.modal.changeSelection'),
                confirm: () => {
                    setAllErrors({})
                    clearChildren(parentId)
                    setData(prev => ({
                        ...prev,
                        typeSubValue: pendingValue,
                    }))
                    closeModal()
                },
                cancel: () => {
                    setData((prev) => ({
                        ...prev,
                        typeSubValue: prevValue,
                    }));
                    closeModal()
                }
            }))
            return
        }

        if (name == 'subCatalog' && hasChild) {
            const prevValue = data.subCatalog
            const pendingValue = value
            setData(prev => ({
                ...prev,
                subCatalog: pendingValue,
            }))
            setModal(prev => ({
                ...prev,
                open: true,
                title: t('optionGroup.modal.confirmation'),
                description: t('optionGroup.modal.changeCatalogSelection'),
                confirm: () => {
                    setAllErrors({})
                    clearChildren(parentId)
                    setData(prev => ({
                        ...prev,
                        subCatalog: pendingValue,
                    }))
                    //Asignar nuevo catalogo al item
                    editItemSubCatalog(itemId, pendingValue);
                    closeModal()
                },
                cancel: () => {
                    setData((prev) => ({
                        ...prev,
                        subCatalog: prevValue,
                    }));
                    closeModal()
                }
            }))
            return
        }

        if (name == 'subCatalog' && !hasChild && value) {
            //Edita ritem para asignar el catalogo
            editItemSubCatalog(itemId, value.value);
        }

        if (name == 'textField' && newSelectedItem?.children.length && value) {
            const prevValue = data.typeSubValue
            const pendingValue = value
            /* setData(prev => ({
                ...prev,
                typeSubValue: pendingValue,
            })) */
            setModal(prev => ({
                ...prev,
                open: true,
                title: t('optionGroup.modal.confirmation'),
                description: t('optionGroup.modal.changeTextInput'),
                confirm: () => {
                    //clearChildren(parentId)
                    setData(prev => ({
                        ...prev,
                        textField: pendingValue,
                    }))
                    closeModal()
                },
                cancel: () => {
                    setData((prev) => ({
                        ...prev,
                        textField: prevValue,
                    }));
                    closeModal()
                }
            }))
            return
        }

        if (name == 'typeSubValue' && !hasChild) {
            setAllErrors({})
            setData({
                subValue: null,
                typeSubValue: value,
                subCatalog: null,
            });
            return;
        }
        body = {
            ...body,
            [name]: value,
        }
        setData(body)
    }, [hasChild, clearChildren, closeModal, parentId, data, t]);

    const handleCSVImport = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = (e) => {
            try {
                const arrayBuffer = e.target?.result as ArrayBuffer;
                if (!arrayBuffer) return;

                const bytes = new Uint8Array(arrayBuffer);

                // 1) Detectar BOM UTF-8 (EF BB BF)
                const hasUtf8Bom = bytes.length >= 3 &&
                    bytes[0] === 0xef && bytes[1] === 0xbb && bytes[2] === 0xbf;

                // Helper: decodificar con TextDecoder
                const decode = (encoding: string) => {
                    try {
                        return new TextDecoder(encoding).decode(bytes);
                    } catch (err) {
                        console.warn("TextDecoder no soporta encoding:", encoding, err);
                        return null;
                    }
                };

                // 2) Intentar UTF-8 inicialmente (si BOM => preferir)
                let text = hasUtf8Bom ? decode("utf-8") || "" : decode("utf-8") || "";

                // 3) Detectar mojibake común (ejemplos: Ã±, Ã¡, Ã©, Â¿, Â¡)
                const mojibakeRegex = /Ã[¡-ñ]|Â[¡¿]| /; // patrón simple para caracteres mojibake o replacement char
                const looksLikeMojibake = mojibakeRegex.test(text);

                if (looksLikeMojibake) {
                    // 4) Reintentar con windows-1252 / iso-8859-1
                    const alt = decode("windows-1252") || decode("iso-8859-1") || "";
                    if (alt && !mojibakeRegex.test(alt)) {
                        text = alt;
                    } else {
                        // si sigue raro, intenta ambos y elige el que parezca mejor (más vocales acentuadas / ñ)
                        const utf8Count = (text.match(/[áéíóúÁÉÍÓÚñÑ]/g) || []).length;
                        const altCount = (alt.match(/[áéíóúÁÉÍÓÚñÑ]/g) || []).length;
                        if (altCount > utf8Count) text = alt;
                    }
                }

                // 5) Parsear con PapaParse a partir del texto decodificado
                Papa.parse<string[]>(text, {
                    header: false,
                    skipEmptyLines: true,
                    complete: (results) => {
                        const flatValues = (results.data as string[][]).flat();
                        const filtered = flatValues.filter((v) => v && v.trim() !== "");
                        const importedValues = filtered.map((value) => ({
                            id: uuidv4(),
                            node: generateId(),
                            label: value,
                            children: [],
                            expand: false,
                            level: level,
                            isEditable: true,
                        }));
                        addItem(parentId, importedValues);

                    },
                    error: (err: Error) => {
                        console.error("Papa parse error:", err);
                    },
                });
            } catch (err) {
                console.error("Error leyendo/decodificando CSV:", err);
            }
        };

        // Leemos como ArrayBuffer para permitir TextDecoder con distintos encodings
        reader.readAsArrayBuffer(file);

        // permitir seleccionar el mismo archivo después
        event.target.value = "";
    };

    const handleSubmit = useCallback(() => {
        if (newSelectedItem) {
            editItem(newSelectedItem.id, data.subValue, undefined, undefined, data.textField,);
            setSelectedItem(itemId, null)
            if (data.textField && newSelectedItem.children.length) {
                clearChildren(newSelectedItem.id)
                collapseItemAndChildren(rootId, newSelectedItem.id)
            }
        } else {
            const newItem: DraggableItem = {
                id: uuidv4(),
                label: data.subValue,
                children: [],
                expand: false,
                level: level,
                isEditable: true,
                textInput: data.textField,
            };
            addItem(parentId, newItem);
        }

        setData({
            subValue: null,
            typeSubValue: OptionValueType.VALUE,
            subCatalog: null,
            textField: null,
        });
    }, [data.subValue, data.textField, parentId, newSelectedItem, addItem, editItem]);

    const handleSubmitFirstLevel = useCallback(() => {
        if (selectedItemRoot) {
            editItem(selectedItemRoot.id, data.category);
            setSelectedItemRoot(null)
        } else {
            const newItem: DraggableItem = {
                id: uuidv4(),
                label: data.category,
                children: [],
                expand: false,
                level: level,
                isEditable: true,
            };
            addItem(parentId, newItem);
        }

        setData({
            //subValue: null,
            //typeSubValue: OptionValueType.VALUE,
            //subCatalog: null,
            category: null
        });
    }, [data.category, parentId, selectedItemRoot, addItem, editItem]);

    const handleSubmitSecondLevel = useCallback(() => {
        if (newSelectedItem) {
            editItem(newSelectedItem.id, data.subCategory, data.priority.value, data.provider?.value, data.textField);
            setSelectedItem(itemId, null)
            if (data.textField && newSelectedItem.children.length) {
                clearChildren(newSelectedItem.id)
                collapseItemAndChildren(rootId, newSelectedItem.id)
            }
            //Falta la prioridad proveedor y campo de te4xto
        } else {
            const newItem: DraggableItem = {
                id: uuidv4(),
                label: data.subCategory,
                children: [],
                expand: false,
                level: level,
                isEditable: true,
                priority: data.priority.value,
                provider: data.provider?.value,
                textInput: data.textField,
            };
            addItem(parentId, newItem);
        }

        setData({
            subCategory: null,
            priority: null,
            provider: null,
            textField: null
        });
    }, [data.subCategory, data.priority, data.provider, data.textField, parentId, newSelectedItem, addItem, editItem]);

    const handleSubmitSubCatalog = useCallback(() => {

        const catalogKey = data.subCatalog.value;
        const predefined = subCatalog.find(cat => cat.value === catalogKey)?.children || [];

        if (predefined.length > 0 && !hasChild) {
            const newItems: DraggableItem[] = predefined.map(item => ({
                id: uuidv4(),
                itemSubCatalogId: item.id,
                label: item.name,
                children: [],
                expand: false,
                level: level,
                isEditable: false,
            }));

            addItem(parentId, newItems);
        }

    }, [data.subCatalog, parentId, addItem, hasChild]);

    const mainInputTypeSubvalue = useMemo<{ [x: string]: InputModel }>(() => ({
        typeSubValue: {
            label: "optionGroup.tags.title.subValueType",
            translate: true,
            name: "typeSubValue",
            type: "select",
            items: subValueTypes,
            value: null,
            rest: { placeholder: "Tipo de plantilla" },
        },
    }), [data.typeSubValue, subValueTypes, t]);

    const mainInputSubValue = useMemo<{ [x: string]: InputModel }>(() => ({
        subValue: {
            label: "optionGroup.tags.title.subValue",
            translate: true,
            name: "subValue",
            type: "text",
            value: data.subValue,
            rest: {
                laceholder: "Ingrese el nombre del subvalor",
                inputProps: {
                    maxLength: 255,
                },
            },
            validate: { required: true },
        }
    }), [data.subValue, t]);

    const mainInputTextField = useMemo<{ [x: string]: InputModel }>(() => ({
        textField: {
            label: 'catalog.inputs.textField',
            translate: true,
            name: 'textField',
            type: 'check',
            //items: priorities,
            value: null,
            wrapChildren: ({ children }) => (
                <Box sx={styles.containerChildrenText}>
                    <Box sx={styles.containerAddText}>
                        <Box sx={styles.childrenText}>{children}</Box>
                        <Box sx={styles.optionsAddText((data.subValue?.trim().length ?? 0) < 3)}>
                            <IconButton
                                className="add"
                                onClick={handleSubmit}
                                disabled={(data.subValue?.trim().length ?? 0) < 3}
                            >
                                {icons("add")}
                            </IconButton>
                        </Box>
                    </Box>
                </Box>
            ),
        }


    }), [data.subValue, t, handleSubmit]);

    const mainInputSubCatalog = useMemo<{ [key: string]: InputModel }>(() => ({
        subCatalog: {
            label: "optionGroup.tags.title.subCatalog",
            translate: true,
            name: "subCatalog",
            type: "select-search",
            items: subCatalog.map((catalog) => ({
                label: catalog.label,
                value: catalog.value,
            })),
            value: data.subCatalog,
            rest: { placeholder: "Seleccione un subcatálogo" },
            validate: { required: true },
            wrapChildren: ({ children }) => (
                <Box sx={styles.containerChildrenSelect}>
                    <Box sx={styles.childrenSelect}>{children}</Box>
                    <Box sx={styles.optionsAdd(!data.subCatalog)}>
                        <IconButton
                            className="add"
                            onClick={handleSubmitSubCatalog}
                            disabled={!data.subCatalog}
                        >
                            {icons("add")}
                        </IconButton>
                    </Box>
                </Box>
            ),
        }


    }), [data.subCatalog, subCatalog, t, handleSubmitSubCatalog]);

    const inputFirstLevel = useMemo<{ [key: string]: InputModel }>(() => {
        const baseInputs: { [key: string]: InputModel } = {
            category: {
                label: "catalog.inputs.category",
                translate: true,
                name: "category",
                type: "text",
                value: data.category,
                rest: {
                    placeholder: "Ingrese el nombre de la categoría",
                    inputProps: {
                        maxLength: 255,
                    },
                },
                validate: { required: true },
                size: { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
                wrapChildren: ({ children }) => (
                    <Box sx={styles.containerChildren}>
                        <Box sx={styles.containerAdd}>
                            <Box sx={styles.children}>{children}</Box>
                            <Box sx={styles.optionsAdd((data.category?.trim().length ?? 0) < 3)}>
                                <IconButton
                                    className="add"
                                    onClick={handleSubmitFirstLevel}
                                    disabled={(data.category?.trim().length ?? 0) < 3}
                                >
                                    {icons("add")}
                                </IconButton>
                            </Box>
                        </Box>

                        <Button sx={styles.subtitle} onClick={() => fileInputRef.current?.click()}>
                            {t("general.importCsv")}
                        </Button>
                    </Box>
                ),
            },
        };

        return baseInputs;
    }, [data.category, handleSubmitFirstLevel]);

    const inputSecondLevel = useMemo<{ [key: string]: InputModel }>(() => {
        const baseInputs: { [key: string]: InputModel } = {
            subCategory: {
                label: "catalog.inputs.subCategory",
                translate: true,
                name: "subCategory",
                type: "text",
                value: data.category,
                rest: {
                    placeholder: "Ingrese el nombre de la subcategoría",
                    inputProps: {
                        maxLength: 255,
                    },
                },
                validate: { required: true },
                size: { xl: 2.5, lg: 2.5, md: 4, sm: 12, xs: 12 },
            },
            priority: {
                label: "catalog.inputs.priority",
                translate: true,
                name: "priority",
                type: "select-search",
                items: priorities,
                value: data.priority,
                //rest: { placeholder: "Seleccione un subcatálogo" },
                validate: { required: true },
                size: { xl: 2.5, lg: 2.5, md: 4, sm: 12, xs: 12 },
            },
            provider: {
                label: "catalog.inputs.provider",
                translate: true,
                name: "provider",
                type: "select-search",
                items: providers,
                value: data.provider,
                //rest: { placeholder: "Seleccione un subcatálogo" },
                validate: { required: true },
                size: { xl: 2.5, lg: 2.5, md: 4, sm: 12, xs: 12 },
            },
            textField: {
                label: 'catalog.inputs.textField',
                translate: true,
                name: 'textField',
                type: 'check',
                //items: priorities,
                value: null,
                size: { xl: 4.5, lg: 4.5, md: 12, sm: 12, xs: 12 },
                wrapChildren: ({ children }) => (
                    <Box sx={styles.containerChildrenText}>
                        <Box sx={styles.containerAddText}>
                            <Box sx={styles.childrenText}>{children}</Box>
                            <Box sx={styles.optionsAddText((data.subCategory?.trim().length ?? 0) < 3 || !data.priority)}>
                                <IconButton
                                    className="add"
                                    onClick={handleSubmitSecondLevel}
                                    disabled={(data.subCategory?.trim().length ?? 0) < 3 || !data.priority}
                                >
                                    {icons("add")}
                                </IconButton>
                            </Box>
                        </Box>
                    </Box>
                ),
            },
        };

        return baseInputs;
    }, [data.subCategory, data.priority, handleSubmitSecondLevel]);



    useEffect(() => {
        setAllErrors({})
        //Nivel uno esta contenido en selectedItemRoot
        if (level == LevelEnums.CATEGORY) {
            if (selectedItemRoot) {
                setData(prev => ({
                    ...prev,
                    category: selectedItemRoot.label,
                }))
            } else {
                setData(prev => ({
                    ...prev,
                    category: null,
                    subCategory: null,
                    priority: null,
                    provider: null,
                    textField: null,
                    subValue: null,
                }))
            }
        } else {
            //Otros niveles esta contenido en selectedItem
            const foundSelectedItem = selectedItem[itemId];
            setNewSelectedItem(foundSelectedItem);
            if (foundSelectedItem) {
                if (level == LevelEnums.SUB_CATEGORY) {
                    setData(prev => ({
                        ...prev,
                        subCategory: foundSelectedItem.label,
                        priority: foundSelectedItem.priority,
                        provider: foundSelectedItem.provider,
                        textField: foundSelectedItem.textInput
                    }))
                }
                if (level > LevelEnums.SUB_CATEGORY) {
                    setData(prev => ({
                        ...prev,
                        subValue: foundSelectedItem.label,
                        textField: foundSelectedItem.textInput
                    }))
                }
            } else {
                setData(prev => ({
                    ...prev,
                    category: null,
                    subCategory: null,
                    priority: null,
                    provider: null,
                    textField: null,
                    subValue: null,
                }))
            }
        }
    }, [selectedItemRoot]);

    useEffect(() => {
        setAllErrors({})
        //Otros niveles esta contenido en selectedItem
        if (level > LevelEnums.CATEGORY) {
            const foundSelectedItem = selectedItem[itemId];
            setNewSelectedItem(foundSelectedItem);
            if (foundSelectedItem) {
                if (level == LevelEnums.SUB_CATEGORY) {
                    setData(prev => ({
                        ...prev,
                        subCategory: foundSelectedItem.label,
                        priority: foundSelectedItem.priority,
                        provider: foundSelectedItem.provider,
                        textField: foundSelectedItem.textInput
                    }))
                }
                if (level > LevelEnums.SUB_CATEGORY) {
                    setData(prev => ({
                        ...prev,
                        subValue: foundSelectedItem.label,
                        textField: foundSelectedItem.textInput
                    }))
                }
            } else {
                setData(prev => ({
                    ...prev,
                    category: null,
                    subCategory: null,
                    priority: null,
                    provider: null,
                    textField: null,
                    subValue: null,
                }))
            }
        }
    }, [selectedItem[itemId]]);


    return (
        <Box sx={styles.container}>
            {level == LevelEnums.CATEGORY && <DinamicForm spacing={{ column: 3, row: 3 }} input={Object.values(inputFirstLevel)} values={data} onChange={mainChange} errors={allErrors} legacyErrors />}

            {level == LevelEnums.SUB_CATEGORY && <DinamicForm spacing={{ column: 3, row: 3 }} input={Object.values(inputSecondLevel)} values={data} onChange={mainChange} errors={allErrors} legacyErrors />}

            {(level > LevelEnums.SUB_CATEGORY && data.typeSubValue === OptionValueType.VALUE) &&
                <Box sx={styles.inputContainer}>
                    <Box sx={styles.inputType}>
                        <DinamicForm input={Object.values(mainInputTypeSubvalue)} values={data} onChange={mainChange} errors={allErrors} legacyErrors />
                    </Box>
                    <Box sx={styles.inputySubValue}>
                        <DinamicForm input={Object.values(mainInputSubValue)} values={data} onChange={mainChange} errors={allErrors} legacyErrors />
                    </Box>
                    <Box sx={styles.inputText}>
                        <DinamicForm input={Object.values(mainInputTextField)} values={data} onChange={mainChange} errors={allErrors} legacyErrors />
                    </Box>

                    <Box sx={styles.inputImport}>
                        <Button sx={styles.subtitleText} onClick={() => fileInputRef.current?.click()}>
                            {t("general.importCsv")}
                        </Button>
                    </Box>


                </Box>
            }

            {(level > LevelEnums.SUB_CATEGORY && data.typeSubValue === OptionValueType.SUB_CATALOG) &&
                <Box sx={styles.inputContainer}>
                    <Box sx={styles.inputType}>
                        <DinamicForm input={Object.values(mainInputTypeSubvalue)} values={data} onChange={mainChange} errors={allErrors} legacyErrors />
                    </Box>
                    <Box sx={styles.inputSubcatalog}>
                        <DinamicForm input={Object.values(mainInputSubCatalog)} values={data} onChange={mainChange} errors={allErrors} legacyErrors />
                    </Box>
                </Box>
            }

            <input
                ref={fileInputRef}
                type="file"
                accept=".csv"
                style={{ display: "none" }}
                onChange={handleCSVImport}
            />

            <SimpleModal
                open={!!modal.open}
                next={modal.confirm}
                back={modal.cancel}
                close={closeModal}
                description={modal.description}
                buttonText={t('general.yes')}
                cancelText={t('general.no')}
                title={modal.title}
                loadingButton={false}
            />
        </Box>
    )
}

export default FormLevel
